import React from 'react';
import {
  Description as DocumentIcon,
  Chat as ChatIcon,
  ContentPaste as FieldsIcon,
  Devices as TechStackIcon,
  Settings as DevelopmentIcon,
  Palette as DesignIcon,
  Security as SecurityIcon,
  Api as ApiIcon,
  FeaturedPlayList as FeaturedPlayListIcon,
  Person as PersonIcon,
  Architecture as ArchitectureIcon,
  AccountTree as FlowIcon,
  Groups as UserRolesIcon,
  AdminPanelSettings as PermissionsIcon,
  Folder as FolderIcon,
  Code as CodeIcon,
  ListAlt as ListAltIcon,
  DesignServices as DesignServicesIcon,
  Psychology as PsychologyIcon,
} from '@mui/icons-material';

/**
 * Returns the appropriate icon component based on icon name
 * @param {string} iconName - Name of the icon
 * @returns {React.ReactElement} Icon component
 */
export const getIconComponent = (iconName) => {
  const icons = {
    'CodeIcon': CodeIcon,
    'ChatIcon': ChatIcon,
    'DescriptionIcon': DocumentIcon,
    'ListAltIcon': ListAltIcon,
    'SettingsIcon': DevelopmentIcon,
    'DesignServicesIcon': DesignIcon,
    'SecurityIcon': SecurityIcon,
    'ApiIcon': ApiIcon,
    'FeaturedPlayListIcon': FeaturedPlayListIcon,
    'PersonIcon': PersonIcon,
    'ArchitectureIcon': ArchitectureIcon,
    'AccountTreeIcon': FlowIcon,
    'GroupsIcon': UserRolesIcon,
    'AdminPanelSettingsIcon': PermissionsIcon,
    'FolderIcon': FolderIcon,
    'ContentPasteIcon': FieldsIcon,
    'DevicesIcon': TechStackIcon,
    'PsychologyIcon': PsychologyIcon,
    'InfoIcon': PsychologyIcon
  };
  
  const IconComponent = icons[iconName] || FolderIcon;
  return <IconComponent fontSize="large" />;
};

export default getIconComponent;